import { Workspace } from "@astral-sh/ruff-wasm-bundler";

let workspaceInstance: Workspace | null = null;

function getWorkspace(): Workspace {
  if (!workspaceInstance) {
    workspaceInstance = new Workspace({
      "line-length": 88,
      "indent-width": 4,
      format: {
        "indent-style": "space",
        "quote-style": "double",
      },
      lint: {
        select: ["E4", "E7", "E9", "F"],
      },
    });
  }
  return workspaceInstance;
}

export async function formatWithRuff(code: string): Promise<string> {
  const ws = getWorkspace();
  try {
    // The .format method itself is synchronous according to the d.ts
    return ws.format(code);
  } catch (e) {
    console.error("Ruff formatting error in formatWithRuff:", e);
    // Fallback to returning the original code on error
    return code;
  }
}
